import { render, staticRenderFns } from "./LmDocumentTypesNewOrEdit.vue?vue&type=template&id=27f8a25b&scoped=true"
import script from "./LmDocumentTypesNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmDocumentTypesNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./LmDocumentTypesNewOrEdit.vue?vue&type=style&index=0&id=27f8a25b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f8a25b",
  null
  
)

export default component.exports